import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';
import EditableVideoThumbnail from './EditableVideoThumbnail';
import { formatEditableVideoMetadataLabel } from './editableVideo.utils';

const styles = {
  card: {
    alignItems: 'stretch',
    border: '1px solid #dbe2e6',
    borderRadius: '8px',
    cursor: 'pointer',
    display: 'flex',
    overflow: 'hidden',
    transition: 'border-color 120ms ease, box-shadow 120ms ease',
    '&:hover': {
      borderColor: '#a7b1c0',
      boxShadow: '0 1px 4px rgba(4, 31, 65, 0.08)',
    },
  },
  content: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    minWidth: 0,
    px: 2,
    py: 1.5,
  },
  title: {
    color: '#041f41',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: 1.3,
  },
  subtitle: {
    color: '#8b93a5',
    fontSize: '13px',
    fontStyle: 'italic',
    lineHeight: 1.4,
    mt: 0.25,
  },
  metadata: {
    color: '#8b93a5',
    fontSize: '13px',
    lineHeight: 1.4,
    mt: 0.5,
  },
};

export default function EditableVideoPreviewCard({ metadata, onClick }) {
  const metadataLabel = formatEditableVideoMetadataLabel(metadata);

  return (
    <Box
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick(event);
        }
      }}
      role="button"
      tabIndex={0}
      sx={styles.card}
      aria-label="Editable video. Click to preview or modify."
    >
      <EditableVideoThumbnail size="card" />
      <Stack sx={styles.content}>
        <Typography sx={styles.title}>Editable video</Typography>
        <Typography sx={styles.subtitle}>Click to preview or modify</Typography>
        {metadataLabel ? (
          <Typography sx={styles.metadata}>{metadataLabel}</Typography>
        ) : null}
      </Stack>
    </Box>
  );
}

EditableVideoPreviewCard.propTypes = {
  metadata: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
    duration_seconds: PropTypes.number,
  }),
  onClick: PropTypes.func.isRequired,
};

EditableVideoPreviewCard.defaultProps = {
  metadata: null,
};
